<template>
    <!-- 称号列表 -->
    <div id="titleTypeDiv" class="wrap" v-if="showTitleTypeList">
        <el-dialog :visible.sync="titleTypeListVisible"
        :before-close="title_type_list_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
                <center>
                    <font color="ff0000" class="title">称号评定</font>
                    <a class="myAbilityEntry" @click.stop="showMyAbilities();">[我的称号]</a>
                </center><hr color="000000">
                <div v-if="null != fantasyTitleTypeBOList" id="fantasyTitleTypeBOList">
                    <div v-for="titleType in fantasyTitleTypeBOList" v-bind:key="titleType.id" :id="titleType.id + '_titleType'" class="titleTypeBlock">
                        <div class="typeTitle">{{titleType.typeName}}</div>
                        <div v-for="titleItem in titleType.fantasyTitleBOList" v-bind:key="titleItem.id" :id="titleItem.id + '_titleItem'">
                            <div class="titleItemRow">
                                <div class="titleItemName">
                                    <div @click.stop="toggleShopOpts('shopOpts_' + titleItem.id, $event);" id="store" class="store">
                                        <a>{{titleItem.title}}</a>
                                        <div :id="'shopOpts_' + titleItem.id"
                                            v-show="shopOpts == 'showshopOpts_' + titleItem.id" class="shopOptsDiv">
                                            <div class="opts" :style="optsStyle">
                                                <a @click.stop="showTitle(titleItem.id);">查看</a>
                                                <a @click.stop="titleEvaluate(titleItem.id);">评定</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="clear:both"></div>
          </div>
        </el-dialog>
        
        <!-- 称号信息 -->
        <el-dialog class="detailwrap" :visible.sync="titleInfoVisible" :before-close="title_info_dialog_close" append-to-body>
            <div class="detailbg">
                <div class="detailTitle">{{fantasyTitleBO.title}}</div>
                <el-row>
                    <el-col>
                        <div class="detailTitleRow">
                            <div>
                                <div class="detailLabel">称号说明：</div>
                                <div class="detailValue" style="text-indent:2em;color: #888888;" :title="fantasyTitleBO.describe">{{fantasyTitleBO.describe}}</div>
                            </div>
                            <div>
                                <div class="detailLabel">需要属性：</div>
                                <div class="detailValue propertyReqList" v-if="null!=fantasyTitleBO.fantasyTitlePropertyRequirementBOList && 0<fantasyTitleBO.fantasyTitlePropertyRequirementBOList.length">
                                    <span class="propertyItem" v-for="propertyRequirement in fantasyTitleBO.fantasyTitlePropertyRequirementBOList"
                                        v-bind:key="propertyRequirement.id" :id="propertyRequirement.id + '_propertyRequirement'">
                                        <span class="propertyName">{{propertyRequirement.describe}}</span>
                                        <span class="propertyValue">{{propertyRequirement.operationSymbol}}{{propertyRequirement.targetValue}}</span>
                                    </span>
                                </div>
                                <div class="detailValue" v-else>没有要求</div>
                            </div>
                            <div>
                                <div class="detailLabel">等级要求：</div>
                                <div class="detailValue">{{fantasyTitleBO.levelMin}}</div>
                            </div>
                            <div>
                                <div class="detailLabel">其他要求：</div>
                                <div class="detailValue">{{fantasyTitleBO.otherRequirement}}</div>
                            </div>
                            <div>
                                <div class="detailLabel">拥有的能力：</div>
                                <div class="detailValue" v-if="null!=fantasyTitleBO.fantasyTitleAbilityBOList && 0<fantasyTitleBO.fantasyTitleAbilityBOList.length">
                                    <div v-for="titleAbility in fantasyTitleBO.fantasyTitleAbilityBOList" 
                                        v-bind:key="titleAbility.id" :id="titleAbility.id + '_titleAbility'">
                                        <div class="propertyName">{{titleAbility.abilityName}}</div>
                                        <div class="propertyValue" style="text-indent:2em;color: #888888;">{{titleAbility.describe}}</div>
                                    </div>
                                </div>
                                <div class="detailValue" v-else>没有特殊能力</div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <!-- 我的称号熟练度 -->
        <el-dialog class="detailwrap" :visible.sync="myAbilitiesVisible" :before-close="my_abilities_dialog_close" append-to-body>
            <div class="detailbg">
                <div class="detailTitle">我的称号</div>
                <div class="myAbilityList" id="myAbilityList">
                    <div v-if="0 == userAbilityList.length" class="myAbilityEmpty">还没有评定过任何称号</div>
                    <div v-for="userAbility in userAbilityList" v-bind:key="userAbility.id" :id="userAbility.id + '_myAbility'" class="myAbilityRow">
                        <div class="myAbilityHead">
                            <span class="myAbilityTitle">{{userAbility.titleName}}</span>
                            <span class="myAbilityStatus" :class="userAbility.status == '1' ? 'active' : 'inactive'">{{userAbility.status == '1' ? '使用中' : '未激活'}}</span>
                        </div>
                        <div class="myAbilityName">{{userAbility.abilityName}}</div>
                        <div class="myAbilityMasteryBar">
                            <div class="myAbilityMasteryFill" :style="{width: masteryPercent(userAbility)}"></div>
                            <span class="myAbilityMasteryText">熟练度 {{userAbility.mastery}}/{{effectiveLimit(userAbility)}}<template v-if="levelCapBinds(userAbility)">（等级上限，{{userAbility.masteryLimit}} 需 {{(userAbility.masteryLimit || 175) / MASTERY_PER_LEVEL}} 级）</template></span>
                        </div>
                        <div class="myAbilityCapBonus" v-if="null != capBonusMap[userAbility.id]">
                            {{capBonusMap[userAbility.id].capText}}
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getRequest} from '../../utils/api'
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import {mapState} from 'vuex'
import {MASTERY_LIMIT_DEFAULT, MASTERY_PER_LEVEL, effectiveMasteryLimit, masteryPercent} from '../../utils/mastery'
export default {
  name: 'titleTypeList',
  props:{
    titleTypeListVisible: {
      type: Boolean,
      default: false
    },
    fantasyUserBO: Object,
  },
  computed: {
    ...mapState('user', ['fantasyUserDetail']),
  },
  data() {
    return {
        MASTERY_PER_LEVEL: MASTERY_PER_LEVEL,
        MASTERY_LIMIT_DEFAULT: MASTERY_LIMIT_DEFAULT,
        fantasyTitleTypeBOList: [],
        loading: false,
        titleInfoVisible: false,
        fantasyTitleBO: {},
        shopOpts: "",
        optsStyle: {},
        myAbilitiesVisible: false,
        userAbilityList: [],
        // 称号上限加成（混子=体力上限/脚夫=疲劳上限），按 userAbilityId 索引，后端为唯一口径来源
        capBonusMap: {},
    };
  },
  watch: {
    titleTypeListVisible: {
      handler(newVal) {
        if (newVal === true) {
          this.showTitleTypeList();
        }
      }
    }
  },
  mounted: function () {
      document.addEventListener('click', this.handleDocumentClick);
      if (this.titleTypeListVisible) {
          this.showTitleTypeList();
      }
  },
  methods: {
    title_type_list_dialog_close(){
      this.$emit("title_type_list_dialog_close");
    },
    //称号列表
    showTitleTypeList: function(){
      this.fantasyTitleTypeBOList = [];
      this.loading = true;
      //称号评定处，查询全部称号信息
        getRequest('/user/title/getFullTitleTree', {
        }).then(resp=> {
          this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              if (null != respData.data) {
                this.fantasyTitleTypeBOList = respData.data;
              }
            } else {
				Message.error(respData.message);
            }
          } else {
            //失败
            Message.error('查询全部称号信息失败');
          }
        }, resp=> {
          Message.error('查询全部称号信息异常');
        });
    },
    title_info_dialog_close() {
        this.titleInfoVisible = false;
    },
    my_abilities_dialog_close() {
        this.myAbilitiesVisible = false;
    },
    //我的称号熟练度列表（含切线后未激活的）
    showMyAbilities: function() {
        this.loading = true;
        getRequest('/user/title/getAllUserAbilities', {
        }).then(resp=> {
          this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              this.userAbilityList = null != respData.data ? respData.data : [];
              this.myAbilitiesVisible = true;
            } else {
                Message.error(respData.message);
            }
          } else {
            //失败
            Message.error('查询我的称号信息失败');
          }
        }, resp=> {
          this.loading = false;
          Message.error('查询我的称号信息异常');
        });
        // 称号上限加成（混子=体力上限/脚夫=疲劳上限）：失败只影响这一行展示，不阻塞列表
        getRequest('/user/title/getTitleCapBonus', {
        }).then(resp=> {
          if (resp.status == 200 && 200 == resp.data.status && null != resp.data.data) {
            this.capBonusMap = resp.data.data;
          }
        }, resp=> {
        });
    },
    masteryPercent: function(userAbility) {
        // 真实上限 = min(称号上限, 等级×5)，与后端双上限同口径
        return masteryPercent(userAbility.mastery, userAbility.masteryLimit, this.fantasyUserDetail.level);
    },
    effectiveLimit: function(userAbility) {
        return effectiveMasteryLimit(userAbility.masteryLimit, this.fantasyUserDetail.level);
    },
    // 等级软上限是否正在压住称号上限（用于给出「175 需 N 级」提示）
    levelCapBinds: function(userAbility) {
        var configured = userAbility.masteryLimit || MASTERY_LIMIT_DEFAULT;
        return effectiveMasteryLimit(userAbility.masteryLimit, this.fantasyUserDetail.level) < configured;
    },
    // 切换显示/隐藏操作浮窗
    toggleShopOpts: function(shopOpts, event) {
        var key = "show" + shopOpts;
        if (this.shopOpts === key) {
            this.shopOpts = "hidden" + shopOpts;
        } else {
            this.shopOpts = key;
            this.optsStyle = { position: 'fixed', top: event.clientY + 'px', left: event.clientX + 'px', zIndex: 999 };
        }
    },
    // 点击其他位置关闭浮窗
    handleDocumentClick: function(e) {
        if (this.shopOpts !== '') {
            var el = e.target;
            if (!el.closest('#titleTypeDiv .store')) {
                this.shopOpts = '';
            }
        }
    },
    showTitle: function(value) {
        var _this = this;
        this.shopOpts = "hidden" + 'shopOpts_' + value;
        getRequest('/user/title/getTitleInfo', {
            titleId: value
        }).then(resp=> {
            if (resp.status == 200) {
                //成功
                var respData = resp.data;
                if (200 == respData.status) {
                    this.titleInfoVisible = true;
                    this.fantasyTitleBO = respData.data;
                } else {
                    this.fantasyTitleBO = {};
				    Message.error(respData.message);
                }
            } else {
                //失败
                Message.error('用户非法⊙﹏⊙∥!');
            }
        }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!');
        });
    },
    titleEvaluate: function(value) {
        var _this = this;
        this.$confirm('请注意，称号评定需支付评定费10000(普通市民除外)，成功后，前一称号及能力将暂时不可用；以后再切换回该称号，称号能力会完整还原，熟练度不会减少，考虑清楚后再进行称号评定吧。', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            postRequest('/user/title/titleEvaluate', {
                titleId: value
            }).then(resp=> {
                if (resp.status == 200) {
                    //成功
                    var respData = resp.data;
                    if (200 == respData.status) {
                        Message.success("评定成功！" + respData.message);
                        _this.title_type_list_dialog_close();
                    } else {
				        Message.error(respData.message);
                    }
                } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!');
                }
            }, resp=> {
                Message.error('用户非法⊙﹏⊙∥!');
            });
        });
    }
  },
  beforeDestroy: function() {
    document.removeEventListener('click', this.handleDocumentClick);
  }
}
</script>

<style scoped>
a {
    cursor: pointer;
    color: blue;
}
.myAbilityEntry {
    font-size: 14px;
    margin-left: 12px;
}
.myAbilityList {
    max-height: 400px;
    overflow-y: auto;
    padding: 6px;
}
.myAbilityEmpty {
    color: #888;
    padding: 20px 0;
    text-align: center;
}
.myAbilityRow {
    background-color: #ffffee;
    text-align: left;
    padding: 8px 10px;
    margin-bottom: 6px;
    border-bottom: 1px solid #e8e8d0;
}
.myAbilityRow:last-child {
    border-bottom: none;
    margin-bottom: 0;
}
.myAbilityHead {
    overflow: hidden;
}
.myAbilityTitle {
    float: left;
    color: #ff8800;
    font-weight: bold;
}
.myAbilityStatus {
    float: right;
    font-size: 12px;
}
.myAbilityStatus.active {
    color: #00a854;
    font-weight: bold;
}
.myAbilityStatus.inactive {
    color: #999;
}
.myAbilityName {
    color: #000;
    font-size: 13px;
    padding: 4px 0;
}
.myAbilityMasteryBar {
    position: relative;
    height: 16px;
    background-color: #e8e8d0;
    overflow: hidden;
}
.myAbilityMasteryFill {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #ff8800;
}
/* 文字铺满整条灰底轨道而非彩色填充条，避免熟练度低时文字被压缩换行 */
.myAbilityMasteryText {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 16px;
    line-height: 16px;
    text-align: center;
    font-size: 12px;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
}
/* 称号上限加成（混子=体力上限/脚夫=疲劳上限）：数值由后端下发 */
.myAbilityCapBonus {
    color: #b8860b;
    font-size: 12px;
    padding-top: 4px;
}
.wrap {
    margin:auto;
    text-align: center;
}
.itembg {
    width:90%;
    max-width: 700px;
    height: auto;
    min-height: 300px;
    max-height: 70vh;
    overflow-y: auto;
    text-align: center;
    margin: 0 auto;
    padding: 10px;
}
#fantasyTitleTypeBOList {
  height: auto;
  min-height: 100px;
}
.title {
    font-size: 20px;
    line-height: 40px;
}
.titleTypeBlock {
    background-color: black;
    padding: 1px;
    margin: 10px;
    text-align: center;
}
.typeTitle {
    color:#fff;
    font-weight: bolder;
    margin: 6px 0;
    padding: 6px 0;
}
.titleItemRow {
    background-color: #ffffee;
    text-align: left;
    border-bottom: 1px solid #e8e8d0;
}
.titleItemRow:last-child {
    border-bottom: none;
}
.titleItemName {
    margin: 0;
}

.store {
    height:36px;
    position:relative;
    margin:0;
    padding: 0 12px;
    cursor: pointer;
}
.store > a {
    display: block;
    line-height: 36px;
    padding: 0 8px;
}
.store:hover {
    background-color: #f0f0d8;
}
.store .opts {
    background-color: #555;
    z-index: 10;
    width: 100px;
    border: 1px solid #888;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}
.store .opts a {
    display: block;
    padding: 8px 10px;
    margin: 0;
    text-decoration: none;
    color: #fff;
    font-size: 13px;
    border-bottom: 1px solid #666;
}
.store .opts a:last-child {
    border-bottom: none;
}
.store .opts a:hover {
    background-color: #777;
    color: #fff;
}
.detailwrap {
    width: 60%;
    max-width: 600px;
}
.detailbg {
    background-color: black;
    padding: 1px;
    margin: 1px;
    text-align: center;
}
.detailTitle {
    color:#fff;
    font-weight: bolder;
    margin: 5px 0;
}

.detailTitleRow {
    background-color: #ffffee;
    text-align: left;
    padding: 4px 0;
}
.detailLabel {
    color: #0088ff;
    padding: 6px 8px;
    font-weight: bolder;
    font-size: 14px;
}
.detailValue {
    color: #000;
    padding: 6px 8px;
    font-size: 14px;
}
.propertyName {
    color: #ff8800;
    padding: 4px 8px;
    font-weight: bold;
}
.propertyValue {
    color: #000;
    padding: 4px 8px;
    font-size: 13px;
}
/* 需要属性：flex 三等分强制每行显示三个，避免 inline 元素宽度不足提前折行 */
.propertyReqList {
    display: flex;
    flex-wrap: wrap;
}
.propertyItem {
    width: 33.33%;
    box-sizing: border-box;
    white-space: nowrap;
    padding: 2px 6px;
}
/* 压缩属性项内部水平内边距，确保三个属性完整显示在一行内 */
.propertyItem .propertyName,
.propertyItem .propertyValue {
    padding: 4px 4px;
}

/* ========== 移动端适配 ========== */
@media screen and (max-width: 768px) {
  .itembg {
    width: 100%;
    max-width: none;
    height: auto;
    min-height: 200px;
    max-height: 80vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    padding: 0;
  }
  .title {
    font-size: 16px;
    line-height: 32px;
  }
  .titleTypeBlock {
    margin: 6px 4px;
    padding: 1px;
    background-color: black;
    text-align: center;
  }
  .typeTitle {
    font-size: 14px;
    color: #fff;
    font-weight: bolder;
    margin: 4px 0;
    padding: 6px 0;
    line-height: 1.4;
  }
  .titleItemRow {
    background-color: #ffffee;
    text-align: left;
  }
  .titleItemRow:last-child {
    border-bottom: none;
  }
  .titleItemName {
    margin: 0;
    font-size: 13px;
  }
  .store {
    height: 36px;
    margin: 0;
    line-height: 36px;
    padding: 0 8px;
  }
  .store a {
    display: block;
    padding: 0;
  }
  .store:hover {
    background-color: #f0f0d8;
  }
  /* 操作浮窗（查看/评定）跟随点击位置 */
  .store .opts {
    width: 110px;
    border-radius: 6px;
    background-color: #555;
    border: 1px solid #888;
    box-shadow: 0 2px 12px rgba(0,0,0,0.3);
  }
  .store .opts a {
    padding: 10px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    border-bottom: 1px solid #666;
  }
  .store .opts a:last-child {
    border-bottom: none;
  }
  /* 称号详情弹窗 */
  .detailwrap {
    width: 92%;
    max-width: none;
  }
  .detailTitle {
    font-size: 16px;
    color: #fff;
  }
  .detailLabel {
    font-size: 13px;
    padding: 3px 6px;
  }
  .detailValue {
    font-size: 12px;
    padding: 3px 6px;
  }
  .propertyName,
  .propertyValue {
    font-size: 12px;
    padding: 2px 6px;
  }
  /* 移动端每行显示两个，避免过窄 */
  .propertyItem {
    width: 50%;
  }
  /* 我的称号熟练度列表 */
  .myAbilityEntry {
    font-size: 13px;
    margin-left: 8px;
  }
  .myAbilityList {
    max-height: calc(60vh - 60px);
    -webkit-overflow-scrolling: touch;
    padding: 4px;
  }
  .myAbilityRow {
    padding: 6px 8px;
  }
  .myAbilityTitle {
    font-size: 14px;
  }
  .myAbilityName {
    font-size: 12px;
  }
}
</style>